import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    _language: navigator.language,
    token: null,
    userName: null,
    userRole: null,
    companyId: null,
    expiration: 0,
    isAuthenticated: false
  },
  mutations: {
    setData(state, val){
        state.token = val.token
        state.username = val.username
        state.position = val.position
        state.userRole = val.role
        state.userId = val.id
        const now = new Date();
        const expirationDate = new Date(now.getTime() + val.expiresIn * 1000);
        state.expiration = expirationDate
        state.isAuthenticated = val.isAuthenticated
        state.companyId = val.companyId
        state.isClient = val.role == "CLIENT" ? true:false
        state.isSupercom = val.role == "SUPERCOM" ? true:false
        state.isAdmin = val.role == "ADMIN" ? true:false
        state.isCom = val.role == "COM" ? true:false
        state.canEdit = val.role == "SUPERCOM" || (!( val.role == "CLIENT") && val.role == "COM")
    },
    setLang(state, val){
        state._language = val
    }
  },
//   actions: {

//   },
//   getters : {

//   }
})

export default store